import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Artists() {
  const [staff, setStaff] = useState([]);
  useEffect(() => { api.get("/staff").then((r) => setStaff(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <span className="kima-overline text-burgundy">Il team</span>
      <h1 className="font-serif text-5xl md:text-6xl text-espresso mt-3 mb-12">Nail Artists</h1>
      <div className="space-y-16">
        {staff.map((a, i) => (
          <div key={a.id} className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 ? "lg:[direction:rtl]" : ""}`}>
            <div className="hover-zoom rounded-sm [direction:ltr]"><img src={a.portrait} alt={a.name} className="w-full aspect-[4/3] object-cover grayscale" /></div>
            <div className="[direction:ltr]">
              <span className="kima-overline text-taupe">{a.level} · {a.role_title}</span>
              <h2 className="font-serif text-4xl text-espresso mt-2 mb-4">{a.name}</h2>
              <p className="text-espresso/70 leading-relaxed mb-5">{a.bio}</p>
              <div className="flex flex-wrap gap-2 mb-6">
                {a.skills.map((s) => (<span key={s} className="text-xs uppercase tracking-wider border border-espresso/20 px-3 py-1 rounded-sm text-espresso/70">{s}</span>))}
              </div>
              <Link to="/prenota" data-testid={`book-artist-${a.id}`} className="inline-block bg-espresso text-ivory px-7 py-3 rounded-sm hover:bg-burgundy transition-colors text-sm">Prenota con {a.name.split(" ")[0]}</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
